import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'greaterThanEqualToAllowance' })
export class GreaterThanEqualToAllowance implements PipeTransform {
  transform(total: number, max: number) {
    return total >= max;
  }
}
